export const init = () => {

  // TRACKER 'MY PURCHASES'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.purchases);

  // changeFilter
  const changeFilter = new AnalyticsTriggerEvent('menu-changeFilter', tracker.defaultEvent());
  changeFilter.trigger = 'change';
  changeFilter.domElement = '#order-filter';
  changeFilter.getLabel = ($element) => {
    const val = $element.val();
    if (val === 'current') return 'CurrentOrder';
    if (val === 'cancelled') return 'CancelledOrder';
    if (val === 'complete') return 'CompleteOrder';
    if (val === 'all') return 'AllOrder';
    return 'ChangeOrderFilter';
  };
  tracker.addEvent(changeFilter);


  // -----
  // Main View :

  // purchasesMakeReturn
  const purchasesMakeReturn = new AnalyticsClickEvent('purchasesMakeReturn', tracker.defaultEvent());
  purchasesMakeReturn.domElement = '[data-tracking="btn-return"]';
  purchasesMakeReturn.options.label = 'Return';
  tracker.addEvent(purchasesMakeReturn);

  // purchasesDetails
  const purchasesDetails = new AnalyticsClickEvent('purchasesDetails', tracker.defaultEvent());
  purchasesDetails.domElement = '[data-tracking="details"]';
  purchasesDetails.options.label = 'Detail';
  tracker.addEvent(purchasesDetails);

  // purchasesCancel
  const purchasesCancel = new AnalyticsClickEvent('purchasesCancel', tracker.defaultEvent());
  purchasesCancel.domElement = '[data-tracking="cancel"]';
  purchasesCancel.options.label = 'Cancel';
  tracker.addEvent(purchasesCancel);

  // purchasesPay
  const purchasesPay = new AnalyticsClickEvent('purchasesPay', tracker.defaultEvent());
  purchasesPay.domElement = '[data-tracking="payment"]';
  purchasesPay.options.label = 'Pay';
  tracker.addEvent(purchasesPay);

  // purchasesAddTicket
  const purchasesAddTicket = new AnalyticsClickEvent('purchasesAddTicket', tracker.defaultEvent());
  purchasesAddTicket.domContainer = '#historical-orders';
  purchasesAddTicket.domElement = 'a.account--my_purchases--past_purchases--link';
  purchasesAddTicket.options.label = 'AddTicket';
  tracker.addEvent(purchasesAddTicket);

  // -----
  // Return view :

  // Return-back
  const purchasesReturnBack = new AnalyticsClickEvent('purchasesReturnBack', tracker.defaultEvent());
  purchasesReturnBack.domElement = '.return-info .row a.cta.grey';
  purchasesReturnBack.options.label = 'ViewReturnBack';
  tracker.addEvent(purchasesReturnBack);

  // Return-validate
  const purchasesReturnValidate = new AnalyticsClickEvent('purchasesReturnValidate', tracker.defaultEvent());
  purchasesReturnValidate.domElement = '#validateReturnButton';
  purchasesReturnValidate.options.label = 'View Return Validate';
  tracker.addEvent(purchasesReturnValidate);

  // Return-back
  const purchasesReturnOtherStore = new AnalyticsClickEvent('purchasesReturnOtherStore', tracker.defaultEvent());
  purchasesReturnOtherStore.domElement = '.return-info #selectStore';
  purchasesReturnOtherStore.options.label = 'ViewReturnSelectStore';
  tracker.addEvent(purchasesReturnOtherStore);


  // -----
  // Details view :

  // Details-back
  const purchasesDetailsBack = new AnalyticsClickEvent('purchasesDetailsBack', tracker.defaultEvent());
  purchasesDetailsBack.domElement = '#order-detail-page [data-tracking="back-button"]';
  purchasesDetailsBack.options.label = 'View Details Back';
  tracker.addEvent(purchasesDetailsBack);

  // Details-cancelOrder
  const purchasesDetailsCancel = new AnalyticsClickEvent('purchasesDetailsCancel', tracker.defaultEvent());
  purchasesDetailsCancel.domElement = '#order-detail-page [data-tracking="order-cancellation"]';
  purchasesDetailsCancel.options.label = 'View Details CancelOrder';
  tracker.addEvent(purchasesDetailsCancel);
  // Details-returnOrder
  const purchasesDetailsReturn = new AnalyticsClickEvent('purchasesDetailsReturn', tracker.defaultEvent());
  purchasesDetailsReturn.domElement = '#order-detail-page [data-tracking="btn-return"]';
  purchasesDetailsReturn.options.label = 'View Details Return';
  tracker.addEvent(purchasesDetailsReturn);
  // Details-payOrder
  const purchasesDetailsPayment = new AnalyticsClickEvent('purchasesDetailsPayment', tracker.defaultEvent());
  purchasesDetailsPayment.domElement = '#order-detail-page [data-tracking="btn-payment"]';
  purchasesDetailsPayment.options.label = 'View Details Payment';
  tracker.addEvent(purchasesDetailsPayment);


  // Cancel view :

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};




// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/purchases-tracker.js